import { useSearchParams } from 'react-router-dom';

export const useGetMarketIdFromSeachParams = () => {
  const [searchParams] = useSearchParams();
  const select = searchParams.get('select');
  return {
    storeId: select?.split('_')[0],
    marketId: select?.split('_')[1],
  };
};
